import { makeStyles } from 'tss-react/mui';

interface PreviewStylesParams {
  height?: string | number;
  width?: string | number;
  maxHeight?: string | number;
  maxWidth?: string | number;
}

export const useStyles = makeStyles<PreviewStylesParams, 'collapseBox'>()(
  ({ breakpoints, tokens, px }, params, classes) => ({
    root: {
      position: 'relative',
    },

    square: {
      paddingTop: '100%',
    },

    document: {
      width: '100%',
      canvas: {
        border: 'none',
      },
      borderRadius: tokens.radius.l,
      overflow: 'hidden',
      transform: 'translate3d(0,0,0)',
    },

    document_square: {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      overflow: 'hidden',
    },

    image: {
      width:
        params.width ?? (params.height || params.maxHeight ? 'auto' : '100%'),
      height: params.height ?? 'auto',
      ...(params.maxHeight && { maxHeight: params.maxHeight }),
      ...(params.maxWidth && { maxWidth: params.maxWidth }),
      ...(params.width && params.height && { objectFit: 'contain' as const }),
    },

    image_square: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },

    centerImage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    previewDocx: {
      minHeight: px(80),
      height: '100%',
    },

    docImage: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: px(36),
      height: px(36),

      [breakpoints.up('sm')]: {
        width: tokens.spacing['56'],
        height: tokens.spacing['56'],
      },
    },

    hiddenPage: {
      display: 'none',
    },

    pagination: {
      position: 'absolute',
      top: tokens.spacing['12'],
      left: tokens.spacing['12'],
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacing['12'],

      [breakpoints.up('md')]: {
        right: tokens.spacing['12'],
        left: 'auto',
      },
    },

    collapseBox: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      borderTop: `${tokens.border.s}px solid ${tokens.colors.stroke.primary}`,
      padding: `${tokens.spacing['4']}px ${tokens.spacing['16']}px`,
      background: tokens.colors.bg.light.primary,
      transform: 'translateY(100%)',
      transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      display: 'flex',
      justifyContent: 'flex-end',
    },

    downloadButton: {
      display: 'flex',
      gap: tokens.spacing['4'],
      alignItems: 'center',
      cursor: 'pointer',
    },

    mobileCollapseBox: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },

    collapseWrapper: {
      position: 'relative',
      ...(params.height && { height: params.height }),
      ...(params.width && { width: params.width }),
      ...(params.maxHeight && { maxHeight: params.maxHeight }),
      ...(params.maxWidth && { maxWidth: params.maxWidth }),

      [`&:hover .${classes.collapseBox}`]: {
        transform: 'translate(0)',
      },
    },

    previewButtons: {
      '& .MuiButton-sizeLarge': {
        width: '72px !important',
      },
    },

    expandButton: {
      position: 'absolute',
      top: tokens.spacing['12'],
      right: tokens.spacing['12'],
    },
  }),
);
